import m from "../factory.js";
import { nowTimestamp as D, getRangeTimestampsContextIntegerPropertyFactory as c } from "../utils.js";
import { startOfDay as f } from "../../utils.js";
const p = 365, y = 1, i = 1, u = c(y, p, i), A = (o) => {
  const e = u(o);
  return m(
    {
      from: ({ now: r, timezone: a, systemToTimezone: s, timezoneToSystem: n }) => {
        const t = new Date(n(f(r, a)));
        return t.setDate(t.getDate() - e.value + 1), s(t);
      },
      to: D
    },
    { numberOfDays: e.descriptor }
  )();
};
export {
  i as DEFAULT_NUM_DAYS,
  p as MAX_NUM_DAYS,
  y as MIN_NUM_DAYS,
  A as default
};
